import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

// Unified patient prefill endpoint (KIN-1215): latest bloods / vitals /
// diagnostics / lifestyle keyed by the FE form keys, for prefilling the
// CDM / OCF / PP review forms. Shape: PatientClinicalDataDto —
// { bloods, vitals, diagnostics, lifestyle }, each field an
// { value, observedAt } pair (value is null when not on record).
export const usePatientClinicalData = (patientId) => {
  const currentPatientId = useCurrentPatientId();
  const selectedPatientId = patientId || currentPatientId;
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientClinicalData", tenantVal, selectedPatientId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientbaseline/clinical-data/${selectedPatientId}`
      );
      return response?.data ?? null;
    },
    enabled: !!tenantVal && !!selectedPatientId,
  });
};
